import {cgTypeEnum} from '../../../utilities/enums/cgTypeEnum';


export enum PortalStep {
  OtpVerifyPhonePage = 'התחברות',
  PlanSelection='בחירת תוכנית',
  ProductSelection='בחירת מכשיר',
  DistributionCenter='מרכזי חלוקה',
  UserPersonalInfo='פרטים אישיים',
  UserPaymentInfo= 'אמצעי תשלום',
  OrderSummary='סיכום הזמנה',
}
export const MessageFormat = {
  Page: 'Page',
  PopUp: 'PopUp',
};
export enum simType {
  Sim='sim',
  Esim='Esim'
}

export const paymentTypes = [
  {title:'כרטיס אשראי', value:cgTypeEnum.CHECKCARD},
  {title:'הוראת קבע', value:cgTypeEnum.DEBTPAYMENT}
]


const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

export const UserStatusMsg = {
    NotExistPlansForUserType: "מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת",
    get IsCellcomNumber() {
      return `שימו לב<br/> זיהינו שהמספר שייך לרשת ${brandNameHe()}`;
    },
    UserNotExistInOrg: "מנוי יקר<br/> הפרטים שהזנת שגויים",
};


export enum PathHistory{
  login='login',
  PersonalInfo="Personal-Info",
  PlanSelection= 'Plan-Selection',
  ProductSelection= 'Product-Selection',
  PaymentInfo= 'Payment-Info',
  UploadFile= 'Upload-File',
  InvalidFile= 'Invalid-File',
  DistributionCenter= 'Distribution-Center',
  OrderSummary='Order-Summary'
}

